import { send } from '../../../../../../src/network/network';
import { type PaginatedCustomerOccasionEntityPreferencesList } from '../../../../../../src/types/PaginatedCustomerOccasionEntityPreferencesList';

type Params = {
  limit?: number;
  offset?: number;
};

export const getApiV2CustomersOccasionEntityPreferencesPath = () =>
  '/api/v2/customers/self/occasion_entity_preferences/';

export async function getApiV2CustomersOccasionEntityPreferences(
  params?: Params
) {
  const queryParams = new URLSearchParams();

  if (params?.limit !== undefined) {
    queryParams.append('limit', params?.limit.toString());
  }

  if (params?.offset !== undefined) {
    queryParams.append('offset', params?.offset.toString());
  }

  return await send<PaginatedCustomerOccasionEntityPreferencesList>({
    path: getApiV2CustomersOccasionEntityPreferencesPath(),
    method: 'GET',
    query: queryParams,
  });
}
